import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { UpdateWorkInviteParams } from '@/features/work/api/update-work-invite/request';
import { updateWorkInvite } from '@/features/work/api/update-work-invite/request';

export const useUpdateWorkInviteMutation = (
  settings?: MutationSettings<UpdateWorkInviteParams, typeof updateWorkInvite>
) =>
  useMutation({
    mutationKey: ['updateWorkInvite'],
    mutationFn: ({ params, config }) =>
      updateWorkInvite({
        params,
        config
      }),
    ...settings?.options
  });
